import { AssetProgressDto } from "@core/typesV2";
import { ActivityProgressService } from "@servicesV2";
import { useMutation } from "@tanstack/react-query";

import { useService } from "./useService";

export type UpdateAssetsMutationParams = {
  courseId: string;
  activityId: string;
  assetProgressDtos: AssetProgressDto[];
};

export function useUpdateAssetsMutation() {
  const { initialization: activityProgressServiceInit } = useService(
    ActivityProgressService,
  );

  return useMutation({
    mutationKey: ["update-assets"],

    mutationFn: async ({
      courseId,
      activityId,
      assetProgressDtos,
    }: UpdateAssetsMutationParams) => {
      const { service: activityProgressService } =
        await activityProgressServiceInit;

      await activityProgressService.updateAssetProgress(
        courseId,
        activityId,
        assetProgressDtos,
      );

      return assetProgressDtos;
    },
  });
}
